import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Car, MapPin, Clock, Star, Shield, Euro } from 'lucide-react';

const TaxiGand = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Taxi Gand (Gent) - Chauffeur Privé Luxe | Service VIP 24/7</title>
        <meta name="description" content="Service de taxi privé de luxe à Gand. Chauffeur professionnel VIP, Mercedes & Lexus, disponible 24/7. Réservation en ligne instantanée." />
        <meta name="keywords" content="taxi gand, chauffeur privé gent, taxi luxe gand, vtc gand, transfert gand" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-gand" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Taxi Gand - Chauffeur Privé de Luxe
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Service VIP 24/7 à Gand (Gent). Véhicules premium Mercedes & Lexus. Réservation instantanée.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Gand" />
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gold">
            Nos Services à Gand
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <MapPin className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Transfert Aéroport</h3>
              <p className="text-gray-400">Gand ↔ Zaventem, Charleroi, Bruxelles. Service porte-à-porte.</p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Car className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Visites Touristiques</h3>
              <p className="text-gray-400">Découvrez Gand avec un chauffeur guide professionnel.</p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Euro className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Prix Fixe</h3>
              <p className="text-gray-400">Tarif connu à l&apos;avance. Aucune surprise.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Taxi Privé de Luxe à Gand</h2>
          <p className="text-gray-300 mb-4">
            Besoin d&apos;un <strong>taxi à Gand</strong> ? Notre service de <strong>chauffeur privé VIP</strong> vous offre 
            un transport premium dans la belle ville médiévale de Gand. Transferts aéroport, déplacements 
            professionnels, visites touristiques - nos chauffeurs sont à votre service 24/7.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Trajets Populaires</h3>
          <ul className="text-gray-300 space-y-2">
            <li>🚗 Gand → Bruxelles (45 min)</li>
            <li>🚗 Gand → Aéroport Zaventem (1h)</li>
            <li>🚗 Gand → Anvers (1h)</li>
            <li>🚗 Gand → Bruges (30 min)</li>
            <li>🚗 Gand → Côte Belge (1h)</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TaxiGand;